import { render, staticRenderFns } from "./SdkMetadata.vue?vue&type=template&id=3c08cc9b&"
import script from "./SdkMetadata.vue?vue&type=script&lang=js&"
export * from "./SdkMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports